import { APIClient } from "../api";
import { SolicitationComment } from "../../models/SolicitationComment";
import SolicitationAttachmentService from '../SolicitationAttachmentService/SolicitationAttachmentService';

export default class SolicitationCommentService extends APIClient {

    constructor(props: any) {
        super(props);
        this.solicitationAttachmentService = new SolicitationAttachmentService(props);
    }

    // const solicitationAttachmentService = new SolicitationAttachmentService(props);
    public solicitationAttachmentService;

    async getCommentsViewBySolicitation(idSolicitation: number) {
        const url = this.endpoint + `/SolicitationComment/Details/${idSolicitation}`;

        return this.api({
            method: 'get',
            url
        })
    }

    async getByHistoryRequester(userId: number, type: any, commentTypes: string, page: string) {
        let url: string;

        if (page === "/Attendance" && type === 1) {
            url = this.endpoint + `/SolicitationComment/History/${userId}?commentTypes=${commentTypes}`
        }
        else {
            url = this.endpoint + `/SolicitationComment/HistoryRequester/${userId}`;
        }

        return this.api({
            method: 'get',
            url
        })
    }

    async getCommentsOnlys(idSolicitation: number, type: string) {
        let url = "";

        if (type == "solicitation") {
            url = this.endpoint + `/SolicitationComment/Details/${idSolicitation}`;
        }
        else if (type == "attendant") {
            url = this.endpoint + `/SolicitationComment/DetailsAttendent/${idSolicitation}`;
        }

        return (await this.api({
            method: 'get',
            url
        })).data;
        //.then(response => {

        //    let count = 0;
        //    response.data.map(comment => {

        //        if (comment.isAttachment) {
        //            count++;

        //            this.solicitationAttachmentService.getItem(comment.attachment)
        //                .then(responseAtt => {

        //                    const blob = new Blob([responseAtt.data]);
        //                    var reader = new FileReader();
        //                    var url = reader.readAsDataURL(blob);

        //                    reader.onload = () => {
        //                        comment.attachment.image = reader.result;
        //                    }
        //                }
        //                )
        //        }
        //    }
        //    )

        //    var promise = new Promise(function (resolve, reject) {
        //        setTimeout(() => {
        //            resolve(response);
        //        }, count * 7000);
        //    })

        //    return promise;
        //})
    }
    //var results: number[] = await Promise.all(arr.map(async (item): Promise<number> => {
    //    await callAsynchronousOperation(item);
    //    return item + 1;
    //}));

    async getCommentsWithAttachments(idSolicitation: number, type: string) {
        let url = "";

        if (type === "solicitation") {
            url = this.endpoint + `/SolicitationComment/Details/${idSolicitation}`;
        }
        else if (type === "attendant") {
            url = this.endpoint + `/SolicitationComment/DetailsAttendent/${idSolicitation}`;
        }
        var response = await this.api({
            method: 'get',
            url
        });

        //          .then(response => {

        let count = response.data.filter(c => c.isAttachment).length;

        await Promise.all(response.data.map(async (comment): Promise<any> => {

            if (comment.isAttachment) {
                count++;

                var responseAtt = await this.solicitationAttachmentService.getItem(comment.attachment);
                //   .then(responseAtt => {

                const blob = new Blob([responseAtt.data]);
                var reader = new FileReader();
                var url = reader.readAsDataURL(blob);

                reader.onload = () => {
                    comment.attachment.image = reader.result;
                }
                // } )
            }
        }
        ))
        return response;
        //var promise = new Promise(function (resolve, reject) {
        //    setTimeout(() => {
        //        resolve(response);
        //    }, count * 7000);
        //})

        //return promise;
        // })
    }

    async newComment(comment: SolicitationComment) {
        const url = this.endpoint + `/SolicitationComment`;

        return this.api({
            method: "post",
            url,
            data: comment
        })
    }

    async VerifyDomainEmails(solicitationId: number, email: string) {
        const url = this.endpoint + `/VerifyDomain/${solicitationId}/${email}`;

        return this.api({
            method: 'get',
            url
        })
    }
}